import { useState } from 'react';

export default function HeroGallery() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const portfolioItems = [
    {
      url: 'https://readdy.ai/api/search-image?query=young%20woman%20content%20creator%20holding%20skincare%20product%20bottle%20smiling%20genuinely%20at%20camera%20in%20bright%20natural%20lighting%20with%20soft%20beige%20background%20professional%20ugc%20style%20authentic%20relatable%20expression&width=360&height=640&seq=port1&orientation=portrait',
      type: 'video',
      category: 'Beauty'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=hands%20holding%20smartphone%20showing%20app%20interface%20with%20coffee%20cup%20on%20wooden%20table%20lifestyle%20content%20creation%20flat%20lay%20warm%20tones%20natural%20lighting%20authentic%20ugc%20style&width=360&height=640&seq=port2&orientation=portrait',
      type: 'video',
      category: 'Tech'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=woman%20unboxing%20fashion%20package%20excited%20expression%20showing%20clothing%20item%20to%20camera%20in%20cozy%20home%20setting%20natural%20daylight%20authentic%20ugc%20creator%20style%20genuine%20reaction&width=360&height=640&seq=port3&orientation=portrait',
      type: 'video',
      category: 'Fashion'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=aesthetic%20breakfast%20table%20setup%20with%20healthy%20food%20and%20supplements%20being%20arranged%20by%20hands%20lifestyle%20wellness%20content%20creation%20bright%20airy%20background%20soft%20shadows&width=360&height=640&seq=port4&orientation=portrait',
      type: 'video',
      category: 'Lifestyle'
    }
  ];

  const brandLogos = ['GlowBeauty', 'TechNova', 'UrbanStyle', 'PureLife', 'SmartGear'];

  return (
    <section className="relative pt-24 pb-12 md:pb-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
        {/* Top Section */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-white border border-stone-200 px-3 md:px-4 py-2 rounded-full mb-4 md:mb-6">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            <span className="text-xs md:text-sm font-medium text-stone-600">Available for Brand Collaborations</span>
          </div>
          
          <h1 className="text-3xl md:text-5xl lg:text-6xl leading-tight mb-4 md:mb-6 text-stone-900 px-4">
            <span className="font-light">Hi, I'm </span>
            <span className="font-bold">Sarah</span>
            <br />
            <span className="font-light">I Create </span>
            <span className="font-bold italic text-amber-700">Scroll-Stopping</span>
            <span className="font-light"> UGC</span>
          </h1>

          <p className="text-base md:text-lg text-stone-500 max-w-2xl mx-auto mb-6 md:mb-10 px-4">
            Helping brands connect with their audience through authentic, high-converting content. 
            Specializing in beauty, tech, fashion & lifestyle niches.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 px-4">
            <a 
              href="#portfolio" 
              className="w-full sm:w-auto bg-stone-900 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-stone-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-play-circle-line text-lg"></i>
              View My Work
            </a>
            <a 
              href="#contact" 
              className="w-full sm:w-auto bg-white border-2 border-stone-900 text-stone-900 px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-stone-900 hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              Get a Quote
            </a>
          </div>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-8 md:mb-12 px-2">
          {portfolioItems.map((item, index) => (
            <div
              key={index}
              className="relative rounded-xl md:rounded-2xl overflow-hidden cursor-pointer group"
              style={{ aspectRatio: '9/16' }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <img
                src={item.url}
                alt={item.category}
                className={`w-full h-full object-cover object-top transition-transform duration-500 ${
                  hoveredIndex === index ? 'scale-110' : 'scale-100'
                }`}
              />
              <div className={`absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent transition-opacity duration-300 ${
                hoveredIndex === index ? 'opacity-100' : 'opacity-0'
              }`}></div>
              
              {/* Play button - always visible */}
              <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
                hoveredIndex === index ? 'opacity-100' : 'opacity-70'
              }`}>
                <div className="w-10 h-10 md:w-14 md:h-14 bg-white/90 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-play-fill text-lg md:text-2xl text-stone-900 ml-1"></i>
                </div>
              </div>
              
              {/* Category tag */}
              <div className="absolute bottom-2 md:bottom-4 left-2 md:left-4 right-2 md:right-4">
                <span className="inline-block bg-white/90 backdrop-blur-sm px-2 md:px-3 py-1 rounded-full text-xs font-medium text-stone-800">
                  {item.category}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Trusted By Brands */}
        <div className="text-center px-4">
          <p className="text-xs uppercase tracking-widest text-stone-400 mb-4 md:mb-6">Trusted by 50+ Brands Including</p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-10">
            {brandLogos.map((brand, index) => (
              <span key={index} className="text-sm md:text-lg font-medium text-stone-300 hover:text-stone-500 transition-colors cursor-default">
                {brand}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
